/*
 *
 * ChatDocumentationIndex constants
 *
 */

export const GET_INDEX_STATUS = 'app/ChatDocumentationIndex/GET_INDEX_STATUS'
export const GET_INDEX_STATUS_SUCCESS =
  'app/ChatDocumentationIndex/GET_INDEX_STATUS_SUCCESS'
export const GET_INDEX_STATUS_ERROR =
  'app/ChatDocumentationIndex/GET_INDEX_STATUS_ERROR'
export const SYNC_INDEX = 'app/ChatDocumentationIndex/SYNC_INDEX'
export const SYNC_INDEX_PROGRESS =
  'app/ChatDocumentationIndex/SYNC_INDEX_PROGRESS'
export const SYNC_INDEX_SUCCESS =
  'app/ChatDocumentationIndex/SYNC_INDEX_SUCCESS'
export const SYNC_INDEX_ERROR = 'app/ChatDocumentationIndex/SYNC_INDEX_ERROR'
